import { format } from 'date-fns';
import FeatherIcon from 'feather-icons-react';

type AccessLog = {
  platform: string;
  location: string;
  datetime: string;
  ip: string;
};

type AccessHistoryTableProps = {
  lastLogins: AccessLog[];
};

export const AccessHistoryTable = ({ lastLogins }: AccessHistoryTableProps) => {
  return (
    <div>
      <div className="mt-4 mb-3 border-bottom pb-2">
        <h5 className="card-title">Últimos logins</h5>
      </div>

      {lastLogins?.length > 0 ? (
        (lastLogins || []).map((login: AccessLog, index: number) => {
          return (
            <div className="d-flex align-items-center mb-3" key={index}>
              <div className="flex-shrink-0 avatar-sm">
                <div className="avatar-title bg-light text-primary rounded-3 fs-18">
                  <FeatherIcon
                    size={16}
                    icon={
                      login.platform === 'Mobile' ? 'smartphone' : 'monitor'
                    }
                  />
                </div>
              </div>
              <div className="flex-grow-1 ms-3">
                <h6>{login.platform}</h6>
                <p className="text-muted mb-0">
                  {login.location} -
                  {format(new Date(login.datetime), "dd/MM/yyyy 'às' HH:mm")}
                </p>
              </div>
              <div>
                <span className="text-primary">{login.ip}</span>
              </div>
            </div>
          );
        })
      ) : (
        <div className="text-center">
          <h5 className="fw-medium">Sem registros de login</h5>
        </div>
      )}
    </div>
  );
};
